package com.shadowings.gero.domain.model

enum class LessonType {
    CHAT,
    SYMBOLS,
    VOCABULARY,
    GRAMMAR,
    QUIZ
}

